module.exports = "a {\n  color: #0074f0; }\n"